import { createTranslations } from '@/i18n/types';

export default createTranslations({
  en: {
    login: 'Log in',
    profileTitle: 'Profile',
    profileReason: 'Log in to view your profile, balance, statistics and activity history.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Log in to upgrade your skins. Pick your skin and try to get a more valuable one.',
    contractsTitle: 'Contracts',
    contractsReason: 'Log in to exchange several of your items for a single new one. The more your items are worth, the higher the contract stake.',
    inventoryTitle: 'Inventory',
    inventoryReason: 'Log in to see your skins. Sell, withdraw to Steam, send to upgrade or contracts.',
    referralsTitle: 'Friends',
    referralsReason: 'Log in to invite friends and earn a share of their drops. Your referral link will appear here.',
    paymentTitle: 'Top up balance',
    paymentReason: 'Log in to top up your SHOT balance and unlock case opening, contracts and upgrades.',
    caseOpenTitle: 'Open the case',
    caseOpenReason: 'Log in to open cases. Your won items go straight to your inventory.',
    caseBattleCreateTitle: 'Create a case battle',
    caseBattleCreateReason: 'Log in to challenge friends to a case battle. Stake your coins, the highest drop wins everything.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Log in to play Rush Mid — turn-based PvP matches against players on the same ticket.',
    rushMidSurveyTitle: 'Rush Mid survey',
    rushMidSurveyReason: 'Log in to take the Rush Mid survey and help make the game better.',
    rouletteTitle: 'Roulette',
    rouletteReason: 'Log in to play roulette — one round, one bank, the odds are equal for everyone.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Log in to join SHOT BAND — a members club with cashback, daily quests and a weekly knife raffle.',
  },
  ru: {
    login: 'Войти',
    profileTitle: 'Профиль',
    profileReason: 'Войди, чтобы посмотреть свой профиль, баланс, статистику и историю активности.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Войди, чтобы прокачивать свои предметы. Выбери свой скин и попробуй получить более ценный.',
    contractsTitle: 'Контракты',
    contractsReason: 'Войди, чтобы обменивать несколько своих предметов на один новый. Чем дороже сумма твоих предметов — тем выше ставка контракта.',
    inventoryTitle: 'Инвентарь',
    inventoryReason: 'Войди, чтобы посмотреть свои скины. Продавай, выводи в Steam, отправляй в апгрейд или контракты.',
    referralsTitle: 'Друзья',
    referralsReason: 'Войди, чтобы приглашать друзей и получать долю с их выпадений. Здесь появится твоя реферальная ссылка.',
    paymentTitle: 'Пополнение баланса',
    paymentReason: 'Войди, чтобы пополнить баланс SHOT и открывать кейсы, контракты, апгрейды.',
    caseOpenTitle: 'Открыть кейс',
    caseOpenReason: 'Войди, чтобы открывать кейсы. Выигранные предметы сразу попадут в твой инвентарь.',
    caseBattleCreateTitle: 'Создать кейс-баттл',
    caseBattleCreateReason: 'Войди, чтобы вызвать друзей на кейс-баттл. Ставь монеты, самый дорогой дроп забирает всё.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Войди, чтобы играть в Rush Mid — пошаговые PvP-матчи с игроками на том же билете.',
    rushMidSurveyTitle: 'Опрос по Rush Mid',
    rushMidSurveyReason: 'Войди, чтобы пройти опрос по Rush Mid и помочь сделать игру лучше.',
    rouletteTitle: 'Рулетка',
    rouletteReason: 'Войди, чтобы играть в рулетку — один раунд, один банк, шансы у всех равны.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Войди, чтобы вступить в SHOT BAND — клуб с кешбэком, ежедневными заданиями и еженедельным розыгрышем ножа.',
  },
  uz: {
    login: 'Kirish',
    profileTitle: 'Profil',
    profileReason: 'Profilingiz, balansingiz, statistikangiz va faollik tarixini koʻrish uchun kiring.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Skinlaringizni apgreyd qilish uchun kiring. Skiningizni tanlab, qimmatroq skinni olishga urining.',
    contractsTitle: 'Kontraktlar',
    contractsReason: 'Bir nechta predmetingizni bittasiga almashtirish uchun kiring. Predmetlar qiymati qancha yuqori boʻlsa, kontrakt stavkasi shuncha yuqori boʻladi.',
    inventoryTitle: 'Inventar',
    inventoryReason: 'Skinlaringizni koʻrish uchun kiring. Sotib, Steamga chiqarib, apgreyd yoki kontraktlarga yuboring.',
    referralsTitle: 'Doʻstlar',
    referralsReason: 'Doʻstlarni taklif qilish va ularning yutuqlaridan ulush olish uchun kiring. Sizning referal havolangiz shu yerda paydo boʻladi.',
    paymentTitle: 'Balansni toʻldirish',
    paymentReason: 'SHOT balansingizni toʻldirib, keyslar ochish, kontraktlar va apgreyd uchun kiring.',
    caseOpenTitle: 'Keysni ochish',
    caseOpenReason: 'Keyslarni ochish uchun kiring. Yutib olingan predmetlar darhol inventaringizga tushadi.',
    caseBattleCreateTitle: 'Keys jang yaratish',
    caseBattleCreateReason: 'Doʻstlaringizni keys jangiga chaqirish uchun kiring. Tangalaringizni tikib, eng qimmat drop hammasini oladi.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Rush Mid oʻynash uchun kiring — bir xil biletli oʻyinchilarga qarshi navbatma-navbat PvP matchlar.',
    rushMidSurveyTitle: 'Rush Mid soʻrovnomasi',
    rushMidSurveyReason: 'Rush Mid soʻrovnomasini toʻldirish va oʻyinni yaxshilashga yordam berish uchun kiring.',
    rouletteTitle: 'Ruletka',
    rouletteReason: 'Ruletka oʻynash uchun kiring — bitta raund, bitta bank, imkoniyatlar hamma uchun teng.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Keshbek, kunlik topshiriqlar va haftalik pichoq lotereyasi bilan SHOT BAND klubiga qoʻshilish uchun kiring.',
  },
  fa: {
    login: 'ورود',
    profileTitle: 'پروفایل',
    profileReason: 'وارد شو تا پروفایل، موجودی، آمار و تاریخچه فعالیتت را ببینی.',
    upgradeTitle: 'ارتقا',
    upgradeReason: 'وارد شو تا اسکین‌هایت را ارتقا بدهی. اسکینت را انتخاب کن و شانست را برای یکی گران‌تر امتحان کن.',
    contractsTitle: 'قراردادها',
    contractsReason: 'وارد شو تا چند آیتمت را با یک آیتم تازه عوض کنی. هرچه آیتم‌هایت گران‌تر باشند، سطح قرارداد بالاتر می‌رود.',
    inventoryTitle: 'انبار',
    inventoryReason: 'وارد شو تا اسکین‌هایت را ببینی. بفروش، به استیم برداشت کن، به ارتقا یا قرارداد بفرست.',
    referralsTitle: 'دوستان',
    referralsReason: 'وارد شو تا دوستانت را دعوت کنی و از دراپ‌هایشان سهم بگیری. لینک دعوتت همین‌جا ظاهر می‌شود.',
    paymentTitle: 'شارژ موجودی',
    paymentReason: 'وارد شو تا موجودی SHOT را شارژ کنی و باز کردن کیس، قرارداد و ارتقا را باز کنی.',
    caseOpenTitle: 'کیس را باز کن',
    caseOpenReason: 'وارد شو تا کیس باز کنی. آیتم‌هایی که می‌بری مستقیم به انبارت می‌روند.',
    caseBattleCreateTitle: 'ساخت نبرد کیس',
    caseBattleCreateReason: 'وارد شو تا دوستانت را به نبرد کیس دعوت کنی. سکه بگذار وسط، گران‌ترین دراپ همه‌چیز را می‌برد.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'وارد شو تا Rush Mid بازی کنی — نبردهای نوبتی PvP با بازیکنانی که هم‌بلیت تو هستند.',
    rushMidSurveyTitle: 'نظرسنجی Rush Mid',
    rushMidSurveyReason: 'وارد شو تا در نظرسنجی Rush Mid شرکت کنی و به بهتر شدن بازی کمک کنی.',
    rouletteTitle: 'رولت',
    rouletteReason: 'وارد شو تا رولت بازی کنی — یک دور، یک بانک، شانس برای همه برابر.',
    bandTitle: 'SHOT BAND',
    bandReason: 'وارد شو تا به SHOT BAND بپیوندی — باشگاه اعضا با کش‌بک، مأموریت‌های روزانه و قرعه‌کشی هفتگی چاقو.',
  },
  pt: {
    login: 'Entrar',
    profileTitle: 'Perfil',
    profileReason: 'Entre para ver seu perfil, saldo, estatísticas e histórico de atividade.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Entre para fazer upgrade das suas skins. Escolha uma skin e tente conseguir uma mais valiosa.',
    contractsTitle: 'Contratos',
    contractsReason: 'Entre para trocar vários itens seus por um novo. Quanto maior o valor dos seus itens, maior o nível do contrato.',
    inventoryTitle: 'Inventário',
    inventoryReason: 'Entre para ver suas skins. Venda, saque para a Steam, mande para upgrade ou contratos.',
    referralsTitle: 'Amigos',
    referralsReason: 'Entre para convidar amigos e ganhar uma parte dos drops deles. Seu link de indicação vai aparecer aqui.',
    paymentTitle: 'Depositar',
    paymentReason: 'Entre para depositar no seu saldo SHOT e abrir caixas, contratos e upgrades.',
    caseOpenTitle: 'Abrir a caixa',
    caseOpenReason: 'Entre para abrir caixas. Os itens que ganhar vão direto para o seu inventário.',
    caseBattleCreateTitle: 'Criar uma batalha de caixas',
    caseBattleCreateReason: 'Entre para desafiar amigos para uma batalha de caixas. Coloque moedas na entrada, o drop mais caro leva tudo.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Entre para jogar Rush Mid — partidas PvP por turnos contra jogadores com o mesmo ingresso.',
    rushMidSurveyTitle: 'Pesquisa sobre o Rush Mid',
    rushMidSurveyReason: 'Entre para responder à pesquisa sobre o Rush Mid e ajudar a melhorar o jogo.',
    rouletteTitle: 'Roleta',
    rouletteReason: 'Entre para jogar roleta — uma rodada, um banco, chances iguais para todos.',
    bandTitle: 'SHOT BAND',
    bandReason: 'Entre para fazer parte do SHOT BAND — um clube com cashback, missões diárias e sorteio semanal de faca.',
  },
  tr: {
    login: 'Giriş yap',
    profileTitle: 'Profil',
    profileReason: 'Profilini, bakiyeni, istatistiklerini ve etkinlik geçmişini görmek için giriş yap.',
    upgradeTitle: 'Upgrade',
    upgradeReason: 'Skinlerini upgrade etmek için giriş yap. Skinini seç ve daha değerlisini almayı dene.',
    contractsTitle: 'Kontratlar',
    contractsReason: 'Birkaç eşyanı tek bir yeni eşyayla takas etmek için giriş yap. Eşyalarının toplam değeri ne kadar yüksekse, kontratın seviyesi o kadar yüksek.',
    inventoryTitle: 'Envanter',
    inventoryReason: "Skinlerini görmek için giriş yap. Sat, Steam'e çek, upgrade'e ya da kontrata gönder.",
    referralsTitle: 'Arkadaşlar',
    referralsReason: 'Arkadaşlarını davet edip droplarından pay almak için giriş yap. Davet linkin burada görünecek.',
    paymentTitle: 'Bakiye yükle',
    paymentReason: 'SHOT bakiyeni yüklemek ve kasa, kontrat, upgrade açmak için giriş yap.',
    caseOpenTitle: 'Kasayı aç',
    caseOpenReason: 'Kasa açmak için giriş yap. Kazandığın eşyalar doğrudan envanterine düşer.',
    caseBattleCreateTitle: 'Kasa savaşı oluştur',
    caseBattleCreateReason: 'Arkadaşlarını kasa savaşına çağırmak için giriş yap. Coinlerini girişe koy, en pahalı drop hepsini alır.',
    rushMidTitle: 'Rush Mid',
    rushMidReason: 'Rush Mid oynamak için giriş yap — aynı biletteki oyunculara karşı sıra tabanlı PvP maçlar.',
    rushMidSurveyTitle: 'Rush Mid anketi',
    rushMidSurveyReason: 'Rush Mid anketini doldurup oyunu daha iyi hale getirmeye yardım etmek için giriş yap.',
    rouletteTitle: 'Rulet',
    rouletteReason: 'Rulet oynamak için giriş yap — bir raund, bir banka, şanslar herkes için eşit.',
    bandTitle: 'SHOT BAND',
    bandReason: "SHOT BAND'e katılmak için giriş yap — cashback, günlük görevler ve haftalık bıçak çekilişi olan bir kulüp.",
  },
});
